import { render } from "./SetPersonPicture.vue?vue&type=template&id=0e31070e&scoped=true&ts=true"
import script from "./SetPersonPicture.vue?vue&type=script&lang=ts"
export * from "./SetPersonPicture.vue?vue&type=script&lang=ts"

import "./SetPersonPicture.vue?vue&type=style&index=0&id=0e31070e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e31070e"]])

export default __exports__